import { createSlice } from '@reduxjs/toolkit';

export const investmentFundsSlice = createSlice({
    name: 'investmentFunds',
    initialState: {
        dataToAction: { name: '', registrationDate: '', percentagePaid: '' }
    },
    reducers: {
        selectInvestmentFunds: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectInvestmentFunds: (state) => {
            state.dataToAction = { whoInvests: '', amount: '', participationValuation:'', vehicle:'' }
        }
    }
});

export const { selectInvestmentFunds, unSelectInvestmentFunds } = investmentFundsSlice.actions;